import { render, staticRenderFns } from "./jala-investor-user.vue?vue&type=template&id=7a46be95&"
import script from "./jala-investor-user.vue?vue&type=script&lang=js&"
export * from "./jala-investor-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports